module.exports = __webpack_public_path__ + "img/rb_logo.2d4ec3af.png";